<template>
  <div style="width: 100%">
    <div class="searchcontent headersearch">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item v-if="permission.isHaveAddPermission">
          <el-button size="small" plain type="primary" icon="el-icon-plus" v-if="adminRegionLevel" @click="onAdd">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="searchtable">
      <el-table ref="table" :data="rolelist" border stripe :row-key="getRowKey" v-loading="showDataLoading" :header-row-style="{ height: '30px' }" :header-cell-style="{ padding: '5px' }" :row-style="{ height: '30px' }" :cell-style="{ padding: '5px' }">
        <el-table-column label="编号" width="60">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称"> </el-table-column>
        <el-table-column label="操作" width="400" v-if="adminRegionLevel">
          <template slot-scope="scope">
            <el-button v-if="permission.isHaveEditPermission" type="text" size="mini" :disabled="scope.row.roleID == 1" @click="editRole(scope.row)">编辑</el-button>
            <el-popconfirm v-if="permission.isHaveDeletePermission" title="您确定要删除么？" iconColor="red" @confirm="deleteRole(scope.row)">
              <el-button style="margin-left: 5px; margin-right: 5px" slot="reference" :disabled="scope.row.roleID == 1" type="text" size="mini">删除</el-button>
            </el-popconfirm>
            <el-button v-if="permission.isHaveDistriutionPermission" type="text" size="mini" :disabled="scope.row.roleID == 1" @click="disPermission(scope.row)">分配权限</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="dialogTitle" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" @close="clearEditList('addRoleForm')" :style="'margin-top:0px;left:' + initLeft()" :visible.sync="dialogAddRoleFormVisible">
      <el-form ref="addRoleForm" :rules="addRoleRules" label-width="120px" :model="addRoleForm">
        <el-form-item prop="roleName" label="角色名称">
          <el-input size="medium" v-model.trim="addRoleForm.roleName" prefix-icon="el-icon-s-custom" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogAddRoleFormVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" :loading="addroleloading" :disabled="addroledisabled" @click="onAddRoleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配权限" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :style="'margin-top:0px;left:' + initLeft()" :visible.sync="dialogDisPermissionFormVisible">
      <v-jstree v-if="dialogDisPermissionFormVisible" class="jstreeclass" :data="menupermissionlists" show-checkbox multiple="multiple" allow-batch whole-row @item-click="itemClick" @item-toggle="itemClicks"></v-jstree>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogDisPermissionFormVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" @click="onAddissueSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { roleModule, secondRoleModule } from "@/request/admin.js";
import router from "@/router.js";
import store from "@/store";
import { permissionTool } from "@/tools/permissiontool.js";
import elDragDialog from "@/directive/el-drag-dialog";
import { baseconfig } from "@/config.js";
import $ from "jquery";
import { sysframe } from "@/tools/sysframe.js";
import VJstree from "vue-jstree";
export default {
  directives: { elDragDialog },
  components: {
    VJstree,
  },
  data() {
    var validateCallRoleName = (rule, value, callback) => {
      if (this.addRoleErrors.roleName) {
        callback(new Error(this.addRoleErrors.roleName));
      } else {
        callback();
      }
    };
    return {
      tableHeight: 400,
      searchTableHeight: 0,
      rolelist: [],
      lsp: [],
      permission: {
        isHaveAddPermission: false,
        isHaveEditPermission: false,
        isHaveDeletePermission: false,
        isHaveDistriutionPermission: false,
      },
      //搜索
      searchForm: {
        keywords: "",
      },
      adminRegionLevel: false,
      //进来加载数据是否展示loading圈
      showDataLoading: true,
      //添加、修改弹出框标识
      dialogMark: "add",
      //添加角色
      dialogAddRoleFormVisible: false,
      addRoleForm: {
        roleName: "",
      },
      addroleloading: false,
      addroledisabled: false,
      addRoleRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { validator: validateCallRoleName },
        ],
      },
      addRoleErrors: {
        roleName: "",
      },
      //修改角色
      editRoleForm: {
        editRoleID: 0,
      },
      //分配权限
      dialogDisPermissionFormVisible: false,
      menupermissionlists: [],
      dialogTitle: "",
      role_id: "",
    };
  },
  created: async function () {
    await this.getRoleList();
    // table的高
    $(".el-table ").css(
      "min-height",
      $(".tab-content").height() -
      30 -
      $(".searchcontent").outerHeight(true) +
      "px"
    );
    if (store.getters.adminRegionLevel <= 1) {
      this.adminRegionLevel = true;
    } else {
      this.adminRegionLevel = false;
    }
    this.permission.isHaveAddPermission = permissionTool.isHavePermission(
      "addrole",
      this.lsp
    );
    this.permission.isHaveEditPermission = permissionTool.isHavePermission(
      "editrole",
      this.lsp
    );
    this.permission.isHaveDeletePermission = permissionTool.isHavePermission(
      "deleterole",
      this.lsp
    );
    this.permission.isHaveDistriutionPermission =
      permissionTool.isHavePermission("distributepermission", this.lsp);
  },
    deactivated: function () {
    this.dialogAddRoleFormVisible = false;
    this.dialogDisPermissionFormVisible = false;
  },
  mounted: function () { },
  methods: {
    initLeft() {
      return sysframe.getSideBarLeft();
    },
    async getRoleList(keywords) {
      await roleModule
        .getRoleList(keywords)
        .then((response) => {
          this.showDataLoading = false;
          switch (response.data.code) {
            case 100:
              this.rolelist = response.data.result;

              this.lsp = response.data.lsp;
              break;
            case 101:
              break;
            case 102:
              var errorMessages = response.data.result;
              var that = this;
              errorMessages.forEach(function (errorMessage) {
                if (errorMessage.field == "adminToken") {
                  router.push("login");
                } else {
                  that.$message.error("获取角色信息失败");
                }
              });
              break;
            case 100002:
              this.$message.error("你没有权限查看角色信息");
              break;
            default:
              this.$message.error("获取角色信息失败");
              break;
          }
        })
        .catch(function (error) { });
    },
    async onSearch() {
      this.rolelist = [];
      if (this.searchForm.keywords.length > 0) {
        await this.getRoleList(this.searchForm.keywords);
      } else {
        await this.getRoleList();
      }
    },
    onAdd() {
      this.dialogAddRoleFormVisible = true;
      this.dialogTitle = "添加角色";
      this.dialogMark = "add";
      this.addRoleForm.roleName = "";
    },
    async onAddRoleSubmit() {
      this.$refs.addRoleForm.validate(async (valid) => {
        if (valid) {
          this.addroleloading = true;
          this.addroledisabled = true;
          if (this.dialogMark == "add") {
            await roleModule
              .addRole(this.addRoleForm.roleName)
              .then((response) => {
                this.addroleloading = false;
                this.addroledisabled = false;
                switch (response.data.code) {
                  case 100:
                    {
                      var newRole = {
                        roleID: response.data.result.roleID,
                        roleName: this.addRoleForm.roleName,
                      };
                      this.rolelist.push(newRole);
                      this.dialogAddRoleFormVisible = false;
                      this.addRoleForm.roleName = "";
                      const h = this.$createElement;
                      this.$notify({
                        title: "成功",
                        message: h("span", "添加成功"),
                        type: "success",
                      });
                      // this.$message({message: '添加成功',type: 'success'});
                    }
                    break;
                  case 101:
                    this.$message.error("添加失败");
                    break;
                  case 103:
                    this.addRoleErrors.roleName = response.data.message;
                    this.$refs.addRoleForm.validateField("roleName");
                    this.addRoleErrors.roleName = "";
                    break;
                  case 102:
                    var errorMessages = response.data.result;
                    var that = this;
                    errorMessages.forEach(function (errorMessage) {
                      if (errorMessage.field == "adminToken") {
                        router.push("login");
                      } else if (errorMessage.field == "role_name") {
                        that.addRoleErrors.roleName = response.data.message;
                        that.$refs.addRoleForm.validateField("roleName");
                        that.addRoleErrors.roleName = "";
                      }
                    });
                    break;
                  case 100002:
                    this.$message.error("您无权限进行此操作");
                    break;
                  default:
                    this.$message.error("修改失败");
                    break;
                }
              })
              .catch(function (error) { });
          } else if (this.dialogMark == "edit") {
            console.log(this.addRoleForm.roleName);
            await roleModule
              .editRole(this.editRoleForm.editRoleID, this.addRoleForm.roleName)
              .then((response) => {
                this.addroleloading = false;
                this.addroledisabled = false;
                switch (response.data.code) {
                  case 100:
                    {
                      var editRoleIndex = this.rolelist.findIndex(
                        (item) => item.roleID === this.editRoleForm.editRoleID
                      );
                      if (editRoleIndex != -1) {
                        this.rolelist[editRoleIndex].roleName =
                          this.addRoleForm.roleName;
                      }
                      this.dialogAddRoleFormVisible = false;
                      this.addRoleForm.roleName = "";

                      const h = this.$createElement;
                      this.$notify({
                        title: "成功",
                        message: h("span", "修改成功"),
                        type: "success",
                      });
                    }
                    // this.$message({message: '修改成功',type: 'success'});
                    break;
                  case 101:
                    this.$message.error("修改失败");
                    break;
                  case 103:
                    this.addRoleErrors.roleName = response.data.message;
                    this.$refs.addRoleForm.validateField("roleName");
                    this.addRoleErrors.roleName = "";
                    break;
                  case 102:
                    var errorMessages = response.data.result;

                    var that = this;
                    errorMessages.forEach(function (errorMessage) {
                      if (errorMessage.field == "adminToken") {
                        router.push("login");
                      } else if (errorMessage.field == "role_name") {
                        that.addRoleErrors.roleName = errorMessage.message;
                        that.$refs.addRoleForm.validateField("roleName");
                        that.addRoleErrors.roleName = "";
                      } else if (errorMessage.field == "role_id") {
                        that.addRoleErrors.roleName = errorMessage.message;
                        that.$refs.addRoleForm.validateField("roleName");
                        that.addRoleErrors.roleName = "";
                      }
                    });
                    break;
                  case 100002:
                    this.$message.error("您无权限进行此操作");
                    break;
                  default:
                    this.$message.error("修改失败");
                    break;
                }
              })
              .catch(function (error) { });
          }
        } else {
          return false;
        }
      });
    },
    editRole(row) {
      this.addRoleForm.roleName = row.roleName;
      this.editRoleForm.editRoleID = row.roleID;
      this.dialogTitle = "编辑角色";
      this.dialogMark = "edit";
      this.dialogAddRoleFormVisible = true;
    },

    itemClick(node, item, e) {
      console.log(333, this.menupermissionlists);
      console.log(222, item, e);
      console.log(111, node.model.text);
    },
    itemClicks(node, item, e) {
      console.log(node.model.opened);
      if (node.model.opened != undefined) {
        if (node.model.opened == true) {
          node.model.icon = "el-icon-folder-opened";
        } else {
          node.model.icon = "el-icon-folder";
        }
      }
    },
    async deleteRole(row) {
      await roleModule
        .deleteRole(row.roleID)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                var editRoleIndex = this.rolelist.findIndex(
                  (item) => item.roleID === row.roleID
                );
                if (editRoleIndex != -1) {
                  this.rolelist.splice(editRoleIndex);
                }
                const h = this.$createElement;
                this.$notify({
                  title: "成功",
                  message: h("span", "删除成功"),
                  type: "success",
                });
              }
              // this.$message({message: '删除成功',type: 'success'})
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
              this.$message.error(baseconfig.no_permission_message);
              break;
            case 102:
              this.$message.error(response.data.message);
              break;
            default:
              this.$message.error(response.data.message);
              break;
          }
        })
        .catch(function (error) { });
    },
    //关闭添加修改弹框时重置
    clearEditList(addRoleForm) {
      this.$refs[addRoleForm].resetFields();
      this.addRoleForm.roleName = "";
      this.$forceUpdate();
    },
    getRowKey(row) {
      return row.roleID;
    },
    async disPermission(row) {
      this.role_id = row.roleID;
      await secondRoleModule
        .getSuRoleMenuRolePermissionList(row.roleID)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              for (let i = 0; i < response.data.result.length; i++) {
                var oneObj = response.data.result[i];
                var towSelect = true;
                if (oneObj.children) {
                  for (let j = 0; j < oneObj.children.length; j++) {
                    var twoObj = oneObj.children[j];
                    var threeSelect = true;
                    if (twoObj.children) {
                      for (let k = 0; k < twoObj.children.length; k++) {
                        var threeObj = twoObj.children[k];
                        var fourSelect = true;
                        if (threeObj.children) {
                          for (let g = 0; g < threeObj.children.length; g++) {
                            const fourObj = threeObj.children[g];
                            if (!fourObj.selected) {
                              fourSelect = false;
                            }
                          }
                          threeObj.selected = fourSelect;
                        }
                        if (!threeObj.selected) {
                          threeSelect = false;
                        }
                      }
                      twoObj.selected = threeSelect;
                      if (!twoObj.selected) {
                        towSelect = false;
                      }
                    }
                  }
                }
                oneObj.selected = towSelect;
              }

              this.menupermissionlists = response.data.result;
              this.dialogDisPermissionFormVisible = true;
              break;
            case 101:
              this.$message.error(response.data.message);
              break;
            case 100002:
              this.$message.error(baseconfig.no_permission_message);
              break;
            case 102:
              this.$message.error(response.data.message);
              break;
            default:
              this.$message.error(response.data.message);
              break;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 确定
    async onAddissueSubmit() {
      let arr = [];
      this.menupermissionlists.forEach((e) => {
        if (e.selected == true) {
          console.log(111, typeof e.id);
          if (typeof e.id != "string") {
            arr.push(e.id);
          }
        }
        if (e.children.length >= 1) {
          e.children.forEach((m) => {
            if (m.selected == true) {
              console.log(typeof m.id);
              if (typeof m.id != "string") {
                arr.push(m.id);
              }
            }
            if (m.children.length >= 1) {
              m.children.forEach((n) => {
                if (n.selected == true) {
                  if (typeof n.id != "string") {
                    arr.push(n.id);
                  }
                }
                if (n.children.length >= 1) {
                  n.children.forEach((i) => {
                    if (i.selected == true) {
                      console.log(555, i.id);
                      if (typeof i.id != "string") {
                        arr.push(i.id);
                      }
                    }
                    if (i.children.length >= 1) {
                      n.children.forEach((a) => {
                        if (a.selected == true) {
                          console.log(555, a.id);
                          if (typeof a.id != "string") {
                            arr.push(a.id);
                          }
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });

      this.addAddissue(this.role_id, arr.toString());
    },

    //添加
    async addAddissue(role_id, permission_ids) {
      console.log(role_id, permission_ids);
      await secondRoleModule
        .batchAddSuRolePermission(role_id, permission_ids)
        .then((response) => {
          // console.log('',response)
          switch (response.data.code) {
            case 100:
              {
                const h = this.$createElement;
                this.$notify({
                  title: "成功",
                  message: h("span", "添加成功"),
                  type: "success",
                });
                this.dialogDisPermissionFormVisible = false;
              }
              break;
            case 101:
              this.$message.error(response.data.message);
              break;
            case 102:
              var errorMessages = response.data.result;
              var that = this;
              errorMessages.forEach(function (errorMessage) {
                if (errorMessage.field == "adminToken") {
                  router.push("login");
                } else {
                  this.$message.error(response.data.message);
                }
              });
              break;
            case 100002:
              this.$message.error("您无权限进行此操作");
              break;
            default:
              this.$message.error(response.data.message);
              break;
          }
        })
        .catch((error) => { });
    },
  },
};
</script>

<style scoped>
/* @import "//cdnjs.cloudflare.com/ajax/libs/jstree/3.2.1/themes/default/style.min.css"; */
.el-tag {
  margin: 7px;
}
.el-button {
  margin: 7px;
}
.headersearch >>> .el-button {
  margin: 0px !important;
}
.bdtop {
  border-top: 1px solid #d9d9d9;
}
.bdbottom {
  border-bottom: 1px solid #d9d9d9;
}
.vcenter {
  display: flex;
  align-items: center;
}
/* .el-table td div{
        margin: 10px 0;
    } */

.permission {
  text-align: left;
}
.jstreeclass >>> span {
  font-size: 18px !important;
}
.jstreeclass >>> span {
  font-size: 18px !important;
}
.jstreeclass >>> .tree-icon {
  background-image: url('../../assets/images/32px.png') !important;
}
.jstreeclass >>> .tree-themeicon {
  background-image: initial !important;
}
.jstreefooter {
  float: left;
  padding: 30px 0;
}
/* .jstreeclass>>>.tree-children{
       max-height:initial !important;
   } */
/* .jstreeclass>>> .tree-icon:empty {
        width: 27px !important;
        height: 25px !important;
        line-height: 25px !important;
    } */
.jstreeclass >>> .el-icon-folder-opened:before {
  font-size: 17px !important;
}
.jstreeclass >>> .el-icon-tickets:before {
  font-size: 17px !important;
}
</style>